// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".gCYXWA7DSh6sLyb6m2Qem {\n    display: flex;\n    align-items: center;\n    margin-left: 16px;\n}\n\n._2RJ7PMNJ11xGXeg9KF3O68 {\n    margin: 0 8px;\n}\n\n.gCYXWA7DSh6sLyb6m2Qem > button + button {\n    margin-left: 8px;\n}\n", ""]);
// Exports
exports.locals = {
	"container": "gCYXWA7DSh6sLyb6m2Qem",
	"offsets": "_2RJ7PMNJ11xGXeg9KF3O68"
};
module.exports = exports;
